module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 8
// module chunks = 0